export const CHANGE_SETTINGS_NAME = 'settings/custom/CHANGE_NAME';
export const ADD_SETTINGS = 'settings/custom/ADD';
export const DELETE_SETTINGS = 'settings/custom/DELETE';
